module.exports = __webpack_public_path__ + "static/img/board2.d170966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/board2.png
// module id = Zn5A
// module chunks = 1